export function dontCopy (node) {
  function preventDefault (e) {
    e.preventDefault();
    return false;
  }
  const events = ['copy', 'cut', 'paste'];

  for (let event of events) {
    node.addEventListener(event, preventDefault, false)
  }

  return {
    destroy() {
      for (let event of events) {
        node.removeEventListener(event, preventDefault, false)
      }
    }
  };
}
